import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from './../../services/context/UserContext';
import { useAuth0 } from '@auth0/auth0-react';
import { jwtDecode } from "jwt-decode";

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user } = useUser();
  const { isAuthenticated, logout } = useAuth0();

  if (!user) {
    const currentUrl = window.location.pathname + window.location.search;
    currentUrl !== '/auth' && localStorage.setItem('redirectUrl', currentUrl);
    return <Navigate to="/auth" replace />;
  }

  try {
    const token = user.token;
    const decodedToken = jwtDecode(token);

    const expirationDate = decodedToken?.exp;
    const nowInSeconds = Math.floor(Date.now() / 1000);

    if (!expirationDate || expirationDate <= nowInSeconds) {
      const currentUrl = window.location.pathname + window.location.search;
      currentUrl !== '/auth' && localStorage.setItem('redirectUrl', currentUrl);
      return <Navigate to="/auth" replace />;
    }

    const isVerified = decodedToken["https://mobiusback.io/user/verified"];
    const roles = decodedToken["https://mobiusback.io/user/organizations/roles"] || [];

    const hasOnlyNewClientRole = roles.length === 1 && roles.includes("prospect");
    const hasAccess = (allowedRoles ?? []).some(role => user?.roles?.includes(role));

    if (hasOnlyNewClientRole) {
      return <Navigate to="/default" replace />;
    }

    if (!isVerified) {
      return <Navigate to="/email-verification" replace />;
    }

    if (!hasAccess) {
      return <Navigate to="/access-denied" replace />;
    }

    return children;
  } catch (error) {
    if (isAuthenticated) {
      logout({ logoutParams: { returnTo: `${window.location.origin}/auth` } });
    }

    return <Navigate to="/auth" replace />;
  }
};
